import { useGregorFlag } from 'mednet-cns/src/hooks/gregor'
import {
  ENABLE_V2_FEED_PAGE_FLAG_KEY,
  ENABLE_EXPERT_DASH_FLAG_KEY,
  ENABLE_MEDNET_GPT_FLAG_KEY,
  ENABLE_CME_COLLECTION_FLAG_KEY,
  ENABLE_CLINICAL_TRIALS_SEARCH_FLAG_KEY,
  ENFORCE_ALGOLIA_QUESTION_SEARCH_IN_AUTO_COMPLETE_FLAG_KEY,
  QUESTION_SEARCH_ALGORITHM_FLAG_KEY,
  SHOW_NEW_SEARCH_MODAL_FLAG_KEY,
} from 'mednet-cns/src/hooks/gregorFlagKeys'

export const useEnableV2FeedPage = () =>
  useGregorFlag(ENABLE_V2_FEED_PAGE_FLAG_KEY, false)

export const useEnableExpertDash = () =>
  useGregorFlag(ENABLE_EXPERT_DASH_FLAG_KEY, false)

export const useEnableMednetGpt = () =>
  useGregorFlag(ENABLE_MEDNET_GPT_FLAG_KEY, false)

export const useEnableCmeCollection = () =>
  useGregorFlag(ENABLE_CME_COLLECTION_FLAG_KEY, false)

export const useEnableClinicalTrialsSearch = () =>
  useGregorFlag(ENABLE_CLINICAL_TRIALS_SEARCH_FLAG_KEY, false)

export const useEnforceAlgoliaQuestionSearchInAutoComplete = () =>
  useGregorFlag(
    ENFORCE_ALGOLIA_QUESTION_SEARCH_IN_AUTO_COMPLETE_FLAG_KEY,
    false
  )

// Default undefined (not false): the only read compares === 'lux_and_llm'.
export const useQuestionSearchAlgorithm = () =>
  useGregorFlag(QUESTION_SEARCH_ALGORITHM_FLAG_KEY, undefined)

export const useShowNewSearchModal = () =>
  useGregorFlag(SHOW_NEW_SEARCH_MODAL_FLAG_KEY, false)
